var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"map",staticStyle:{"height":"300px"},attrs:{"zoom":_vm.zoom,"center":{lat: _vm.place.lat, lng: _vm.place.lng},"map-type-id":"hybrid","draggable":"true"},on:{"click":_vm.updatePointer}},[(_vm.place)?_c('gmap-marker',{attrs:{"position":{lat: _vm.place.lat, lng: _vm.place.lng},"draggable":_vm.canUpdatePointer,"label":"★"},on:{"dragend":_vm.updatePointer}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60b4feae","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccessibilityMap.vue
// module id = 888
// module chunks = 1